import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { ROUTES } from 'src/app/core/constants/routes-constants';
import { AuthorizeService } from '../services/authorize.service';
import { map } from 'rxjs/operators';

@Injectable()
export class RightsGuard {
  constructor(
    private _router: Router,
    private _globalService: GlobalService,
    private _authorizeService: AuthorizeService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this._authorizeService.isAuthenticated$.pipe(
      map(isAuth => {
        const userProfile = this._globalService.user;

        if (userProfile && userProfile.userId && userProfile.isActive) {
          this._globalService.hasUserRightsSubject$.next(true);

          if (userProfile.userAllowedRoutes.some(userAllowedRoute => route.url[0].path.startsWith(userAllowedRoute))) {
            return true;
          }

          this._router.navigate([ROUTES.UNAUTHORIZED_ROUTE_URL]);
          return false;
        }

        this._globalService.hasUserRightsSubject$.next(false);
        if (isAuth) {
          this._router.navigate(['/' + ROUTES.INVALID_ACCOUNT]);
        }
        return false;
      })
    );
  }
}
